import { createRoot } from 'react-dom/client';
import VendorSearch from "./vendor-search";
import TestDrive from "./testdrive";
import Membership from "./membership";
import Financing from "./financing";
// import 'mapbox-gl/dist/mapbox-gl.css';

const vendorSearchElement = document.getElementById('vendor-search');
if (vendorSearchElement) {
  const classification = vendorSearchElement.dataset.classification || 'CU';
  const root = createRoot(vendorSearchElement);
  root.render(<VendorSearch classification={classification} />);
}

const testDriveElement = document.getElementById('testdrive');
if (testDriveElement) {
  const classification = testDriveElement.dataset.classification || '';
  console.log('TestDrive dataset:', testDriveElement.dataset);
  const isClassificationFixed = testDriveElement.dataset.isClassificationFixed === 'true';
  const vendorId = testDriveElement.dataset.vendorId || null;
  const modelId = testDriveElement.dataset.modelId || null;
  const root = createRoot(testDriveElement);
  root.render(<TestDrive classification={classification} isClassificationFixed={isClassificationFixed} vendorId={vendorId} modelId={modelId} />);
}

const membershipElement = document.getElementById('membership');
if (membershipElement) {
  const root = createRoot(membershipElement);
  root.render(<Membership />);
}

const financingElement = document.getElementById('financing');
if (financingElement) {
  const price = parseFloat(financingElement.dataset.price) || 0;
  const root = createRoot(financingElement);
  root.render(<Financing price={price} />);
}
